<template>
  <v-app>
    <v-app-bar
        app
        clipped-left
        color="primary"
        :dark="$vuetify.theme.dark">
      <v-app-bar-nav-icon
          v-test="{ menu: '' }"
          @click.stop="drawer = !drawer" />
      <a :href="segmentConfig.mainSegmentLink" class="main-link">
        <img
            :height="$vuetify.breakpoint.smAndDown ? 40 : 45"
            class="ml-2 clickable"
            :src="logoTop">
      </a>
      <v-toolbar-title
          :style="$vuetify.breakpoint.smAndUp
            ? ''
            : 'min-width: 72px'"
          class="ml-0 pl-3">
        <a :href="segmentConfig.mainSegmentLink" class="main-link">
          <span class="hidden-sm-and-down">
            {{ segmentName }}
          </span>
        </a>
      </v-toolbar-title>
      <v-spacer />
      <header-actions />
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        class="nav-drawer"
        left
        clipped
        app>
      <v-list dense nav>
        <v-list-item-group v-model="selection">
          <template v-for="(group, ndx) in menuItems">
            <v-subheader
                v-if="group.heading && group.show"
                :key="ndx"
                row
                align-center
                class="title">
              {{ group.heading }}
            </v-subheader>
            <v-list-item
                v-for="(item, ind) in group.list.filter(i => i.show)"
                :key="ind+item.text"
                v-test="item.id
                  ? { 'left-menu': item.id }
                  : null"
                link
                v-bind="item.route
                  ? { to: { path: item.route } }
                  : {}"
                v-on="item.method
                  ? { click: item.method }
                  : {}">
              <v-list-item-icon>
                <v-icon v-text="item.icon" />
              </v-list-item-icon>
              <v-list-item-content
                  class="text-left align-self-start">
                <v-list-item-title v-text="item.text" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main app class="pt-4 mt-15">
      <v-container fluid class="mb-4 pt-0">
        <access-expiration-date-alert
            v-if="isRegistered" />
        <router-view />
      </v-container>
    </v-main>
    <v-footer absolute app>
      <footer-content />
    </v-footer>
  </v-app>
</template>

<style scoped>
.main-link {
  color: white;
  text-decoration: none;
}
.nav-drawer {
  max-height: 100% !important;
}
.v-list-item__title {
  white-space: pre-wrap !important;
}
</style>

<script>
  import HeaderActions from './HeaderActions.vue'
  import FooterContent from './FooterContent.vue'
  import AccessExpirationDateAlert from './AccessExpirationDateAlert.vue'

  export default {
    name: 'App',
    components: {
      HeaderActions,
      FooterContent,
      AccessExpirationDateAlert
    },
    props: {
      menuItems: {
        type: Array,
        required: true
      }
    },
    data: vm => ({
      drawer: null,
      selection: 0
    }),
    computed: {
      logoTop () {
        return this.systemLocale === 'ru'
          ? this.getSystemFileUrl('logo_white_short.png')
          : this.getSystemFileUrl('logo_white_short_en.png')
      },
      segmentName () {
        return this.systemLocale === 'ru'
          ? this.segmentConfig.segmentNameRu
          : this.segmentConfig.segmentNameEn
      },
      segmentShortName () {
        return this.systemLocale === 'ru'
          ? this.segmentConfig.segmentShortNameRu
          : this.segmentConfig.segmentShortNameEn
      }
    },
    watch: {
      segmentShortName: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            document.title = this.$t('ЭПЭ ({0})', [this.segmentName])
          }
        }
      }
    }
  }
</script>
